import { CoveragesPage } from "../views/Coverages/CoveragesPage";
import { CoveragesAssignPage } from '../views/CoveragesAssign/CoveragesAssignPage'
import { CoverageGroupsPage } from '../views/CoverageGroups/CoverageGroupsPage'
import RouteIcon from '@mui/icons-material/Route';
import { PERMISSIONS } from 'router/permissions';

export const routesRoutes = [
    {
        collapse: true,
        name: "Estaciones",
        icon: RouteIcon,
        state: "pageCollapse",
        inSidebar: true,
        isProtected: true,
        rule: PERMISSIONS.STATIONS,
        views: [
            {
                path: "/coverages",
                name: "Coberturas",
                mini: "CB",
                component: CoveragesPage,
                layout: "/admin",
                inSidebar: true,
                isProtected: true,
                rule: PERMISSIONS.COVERAGES,
            },
            {
                path: "/coverages_assign",
                name: "Asignación de coberturas",
                mini: "CBA",
                component: CoveragesAssignPage,
                layout: "/admin",
                inSidebar: true,
                isProtected: true,
                rule: PERMISSIONS.COVERAGES_ASSIGN,
            },
            {
                path: "/rutas_coberturas",
                name: "Rutas para coberturas",
                mini: "RC",
                component: CoverageGroupsPage,
                layout: "/admin",
                inSidebar: true,
                isProtected: true,
                rule: PERMISSIONS.COVERAGE_GROUPS,
            }
        ],
    },
]